import casify from './casify';

export function snakifyString(string) {
  return string.replace(/([A-Z]|[0-9]+)/g, (match, firstCharacter) => (`_${firstCharacter.toLowerCase()}`));
}

export const snakify = casify(snakifyString);

export default snakify;
